import { render, staticRenderFns } from "./editar_regiao.vue?vue&type=template&id=8539be10&scoped=true"
import script from "./editar_regiao.vue?vue&type=script&lang=js"
export * from "./editar_regiao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8539be10",
  null
  
)

export default component.exports